// Constants for SafeHaven Scorecard

export const INSURANCE_TYPES = [
  "INSUR[10-to-1]",
  "INSUR[12-to-1]",
  "INSUR[15-to-1]",
];

export const INITIAL_ALLOC = {
  firstAssetAlloc: 72,
  secondAssetAlloc: 28,
};

export const INITIAL_DATA_BAR = {
  labels: ["data1", "data2"],
  datasets: [
    {
      label: ["data1", "data2"],
      data: [0, 0],
      backgroundColor: "rgba(255, 99, 132, 0.5)",
    },
  ],
};

export const INITIAL_REGIME_BAR = {
  labels: ["Loading", "Loading", "Loading"],
  datasets: [],
};

export const DEFAULT_YEAR_RANGE = {
  fromYear: 1901,
  toYear: 2020,
};

export const DEFAULT_API_YEAR_RANGE = {
  fromYear: 1901,
  toYear: 2025,
};

export const SIMULATION_CONFIG = {
  selectedValueFlip: 25,
  selectedValuePath: 1000,
};
